import React from 'react';
import { FieldArray, useFormikContext } from 'formik';

import { FormikTaskBuilderValues } from '../../admin-console-volunteer-profile-model';
import { ContentTaskItemDialog } from '../dialogs/ContentTaskItemDialog';
import { FieldTaskItemDialog } from '../dialogs/field-task-item-dialog/FieldTaskItemDialog';
import { Program } from '../dialogs/field-task-item-dialog/FieldVisibilityControl';
import { HeadingTaskItemDialog } from '../dialogs/HeadingTaskItemDialog';
import { MediaTaskItemDialog } from '../dialogs/MediaTaskItemDialog';
import { useFormBuilderDialogContext } from '../FormBuilderDialogContext';
import { TaskListItemContextProvider } from '../TaskListItemsContext';
import { TaskItemList } from './TaskItemList';

interface TaskListItemsFormProps {
  programs?: Program[]; // Optional - only provided for volunteer profile task
  isTaskZero?: boolean; // True if this is the volunteer profile task (order === -1)
}

export function TaskListItemsForm({ programs, isTaskZero }: TaskListItemsFormProps) {
  const { values, setFieldValue } = useFormikContext<FormikTaskBuilderValues>();

  const {
    openHeadingDialogState,
    closeHeadingDialog,
    openContentDialogState,
    closeContentDialog,
    openFieldDialogState,
    closeFieldDialog,
    openMediaDialogState,
    closeMediaDialog,
  } = useFormBuilderDialogContext();

  return (
    <FieldArray name='taskItems'>
      {(arrayHelpers) => (
        <>
          <TaskListItemContextProvider taskItems={values.taskItems} setFieldValue={setFieldValue}>
            <TaskItemList />
          </TaskListItemContextProvider>
          <HeadingTaskItemDialog
            open={openHeadingDialogState.open}
            close={closeHeadingDialog}
            arrayHelpers={arrayHelpers}
            data={openHeadingDialogState.data}
            programs={programs}
            isTaskZero={isTaskZero}
          />
          <ContentTaskItemDialog
            open={openContentDialogState.open}
            close={closeContentDialog}
            arrayHelpers={arrayHelpers}
            data={openContentDialogState.data}
            programs={programs}
            isTaskZero={isTaskZero}
          />
          <FieldTaskItemDialog
            open={openFieldDialogState.open}
            close={closeFieldDialog}
            arrayHelpers={arrayHelpers}
            data={openFieldDialogState.data}
            programs={programs}
            isTaskZero={isTaskZero}
          />
          <MediaTaskItemDialog
            open={openMediaDialogState.open}
            close={closeMediaDialog}
            arrayHelpers={arrayHelpers}
            data={openMediaDialogState.data}
          />
        </>
      )}
    </FieldArray>
  );
}
